export default class DecryptageFilters {
  static getPageContent() {
    if (window?.API && window.API['fake-news-nos-reponses']) {
      return window.API['fake-news-nos-reponses'];
    }
    return {
      dictionnary: {
        wordings: {
          title_fakenews_main: 'Bienvenue dans le service',
          subtitle_fakenews_main: '“fake news” de Santé.fr',
          btn_decryptage: 'Accéder aux décryptages',
          btn_pedagogie: 'Voir toute la rubrique',
          title_pedagogie: 'À qui se fier ?',
          title_decryptage_article: 'Sur le même thème',
          title_pedagogie_article: 'Dans la même rubrique',
          title_fakenews_decryptage: 'La rubrique décryptage',
          menu_main: 'Accueil Fake News',
          menu_decryptage: 'Décryptage Fake News',
          menu_pedagogie: 'A qui se fier ? Fake News',
        },
        fakenews_types: {
          4: 'Fake news - décryptage',
          5: 'Fake news - pédagogie',
        },
        categories_fake_news: {
          222233: {
            id: '222233',
            name: 'Nutrition / perte de poids',
          },
          222235: {
            id: '222235',
            name: 'Bien être / hygiène de vie',
          },
          222237: {
            id: '222237',
            name: 'Recherches et essais cliniques',
          },
          222239: {
            id: '222239',
            name: 'Médicaments et dispositifs médicaux',
          },
          222241: {
            id: '222241',
            name: 'Fin de vie',
          },
          222243: {
            id: '222243',
            name: 'Enfants',
            childs: {
              4441: {
                id: 4441,
                name: 'Enfants1',
              },
              4442: {
                id: 4442,
                name: 'Enfants2',
              },
              4443: {
                id: 4443,
                name: 'Enfants3',
              },
            },
          },
          222245: {
            id: '222245',
            name: 'Santé des femmes',
          },
          222247: {
            id: '222247',
            name: 'Santé sexuelle',
          },
          222249: {
            id: '222249',
            name: 'Cancers',
            childs: {
              2222435: {
                id: '2222435',
                name: 'Santé des feCancersmmes',
              },
              2222531: {
                id: '2222531',
                name: 'Santé menCancerstale',
              },
              2222533: {
                id: '2222533',
                name: 'Santé Cancers',
              },
            },
          },
          222251: {
            id: '222251',
            name: 'Santé mentale',
          },
          222253: {
            id: '222253',
            name: 'Santé environnementale',
          },
          222255: {
            id: '222255',
            name: 'Dépendances / addictions',
          },
          222257: {
            id: '222257',
            name: 'Covid-19',
          },
          222259: {
            id: '222259',
            name: 'Maladies infectieuses',
          },
          222261: {
            id: '222261',
            name: 'Vaccination',
            childs: {
              222245: {
                id: '222245',
                name: 'Santé des femmes',
              },
              222251: {
                id: '222251',
                name: 'Santé mentale',
              },
              222253: {
                id: '222253',
                name: 'Santé environnementale',
              },
            },
          },
        },
      },
      nodes: {
        api: '/api/fake-news',
        method: 'GET',
        params: {
          page: 0,
          type: 4,
          category: '222261,222245,222251',
        },
      },
    };
  }
}
